import EmptyState from "ds/components/EmptyState";
import Button from "ds/components/Button";
import Box from "ds/components/Box";
import { EmptystatePuzzleColored } from "components/icons/generated";

import { showCreateSpaceliftVcsRepoDrawer } from "./CreateSpaceliftVcsRepoDrawer";

type SpaceliftVcsReposEmptyProps = {
  hasNoSearchResult?: boolean;
};

const SpaceliftVcsReposEmpty = ({ hasNoSearchResult }: SpaceliftVcsReposEmptyProps) => {
  return hasNoSearchResult ? (
    <EmptyState
      title="No results"
      caption={`Don't give up! Check the spelling or try something less specific.`}
      icon={EmptystatePuzzleColored}
    />
  ) : (
    <EmptyState
      title="No repos yet"
      caption="Spacelift VCS allows you to store and manage your infrastructure code directly in Spacelift."
      icon={EmptystatePuzzleColored}
    >
      <Box gap="medium">
        <Button variant="primary" onPress={() => showCreateSpaceliftVcsRepoDrawer()}>
          Create your first repo
        </Button>
      </Box>
    </EmptyState>
  );
};

export default SpaceliftVcsReposEmpty;
